import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { getPostDetails } from '../../utils/api';

const Post = () => {
    const { threadId, postId } = useParams(); // Hole die Thread- und Post-ID aus der URL
    const [post, setPost] = useState(null);

    useEffect(() => {
        const fetchPostDetails = async () => {
            try {
                const data = await getPostDetails(threadId, postId);
                setPost(data.post);
            } catch (err) {
                console.error('Error fetching post details', err);
            }
        };

        fetchPostDetails();
    }, [threadId, postId]);

    if (!post) {
        return <div>Loading...</div>;
    }

    return (
        <>
            <h1>{post.title}</h1>
            <p>{post.content}</p>
            <p>Posted by: {post.user.name}</p>
        </>
    );
};

export default Post;
